import React from "react";
import { Message, Transition } from "semantic-ui-react";
import { SemanticCOLORS } from "semantic-ui-react/dist/commonjs/generic";
import { getErrorColor, getErrorMessage } from "../../Helpers";
import { IErrorResponse } from "../interfaces/Global";
import BCNewLine from "./BCNewLine";
import "../../styles/ui.scss";

interface BPProps {
  animation?: string;
  duration?: number;
  visible?: any;
  transitionOnMount?: boolean;
  styles?: string;
  negative?: boolean;
  color?: SemanticCOLORS;
  onDismiss?: any;
  compact?: boolean;
  header?: string;
  clickable?: any;
  text?: any;
  errorResponse?: IErrorResponse;
  custom?: any;
}
const BCMessage = ({ ...props }: BPProps) => {
  const errorResponse = props.errorResponse;
  const errorText = errorResponse && errorResponse.errorMessage ? <BCNewLine text={getErrorMessage(errorResponse.errorId, errorResponse.errorMessage)} /> : "";
  return (
    <Transition animation={props.animation} duration={props.duration} visible={props.visible} transitionOnMount={props.transitionOnMount}>
      {errorResponse ? <Message className={props.styles} negative={props.negative} color={getErrorColor(errorResponse && errorResponse.errorLevel ? errorResponse.errorLevel : "red")} onDismiss={props.onDismiss} compact={props.compact}>
          <Message.Header>{errorResponse.errorTitle ? errorResponse.errorTitle : ""}</Message.Header> 
          {props.clickable ? <div className="cursor-pointer" onClick={props.clickable}>{errorText}</div> : <p>{errorText}</p>}
        </Message> : <Message className={props.styles} negative={props.negative} color={props.color} onDismiss={props.onDismiss} compact={props.compact}>
        <Message.Header>{props.header}</Message.Header> 
        {props.custom ? props.custom : props.clickable ? <div className="cursor-pointer" onClick={props.clickable}>{props.text}</div> : <p>{props.text}</p>}
      </Message>}
    </Transition>
  );
};

export default BCMessage;